import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import IntroCard from 'components/IntroCard'
import { RowBetween } from 'components/Row'
import { useActiveWeb3React } from 'hooks'
import React, { useContext } from 'react'
import { useWalletModalToggle } from 'state/application/hooks'
import styled, { ThemeContext } from 'styled-components'
import { TYPE } from 'theme'
import HSPXPoolCard from './HSPXPoolCard'
import STHYPEPoolCard from './stHYPEPoolCard'
import HypePoolCard from './HypePoolCard'
import { Helmet } from 'react-helmet'
import LHYPEPoolCard from './lHYPEPoolCard'

const ContainerStyled = styled.div`
  width: 100%;
  max-width: 870px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 200px;
  padding: 10px;
`

const GridStyled = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const ConnectWalletContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  min-height: 25vh;
  background: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 14px;
  width: 100%;

  div {
    max-width: 300px;
  }
`
const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    flex-direction: column-reverse;
  `};
`

const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  padding: 18px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
`

const StakeList = () => {
  const { account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const theme = useContext(ThemeContext)

  return (
    <>
      <Helmet>
        <title>Stake Tokens | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Earn rewards by staking your tokens on HyperSwap Exchange. Start staking today to maximize your token yield."
        />
        <meta
          name="keywords"
          content="HyperSwap staking, stake tokens, earn rewards, crypto staking, DeFi staking, Hyperliquid EVM"
        />
        <meta property="og:title" content="Stake Tokens | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Stake your tokens and earn rewards on HyperSwap Exchange. Take advantage of DeFi opportunities."
        />
        <meta property="og:url" content={`${window.location.origin}/#/stake`} />
      </Helmet>
      <ContainerStyled>
        <IntroCard variant={1} Key="Stake list">
          <h1>Stake</h1>
          <p>Select the assets you want to stake.</p>
        </IntroCard>

        <AutoColumn gap="lg" justify="center">
          <AutoColumn gap="lg" style={{ width: '100%' }}>
            <TitleRow style={{ marginTop: '1rem' }} padding={'0'}>
              <TYPE.mediumHeader>{'Staking Pools Overview'}</TYPE.mediumHeader>
            </TitleRow>
            {!account ? (
              <ConnectWalletContainer>
                <div>
                  <TYPE.mediumHeader textAlign="center" color={theme.text3}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-tax"
                      style={{ marginBottom: '.5rem' }}
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M8.487 21h7.026a4 4 0 0 0 3.808 -5.224l-1.706 -5.306a5 5 0 0 0 -4.76 -3.47h-1.71a5 5 0 0 0 -4.76 3.47l-1.706 5.306a4 4 0 0 0 3.808 5.224" />
                      <path d="M15 3q -1 4 -3 4t -3 -4z" />
                      <path d="M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                      <path d="M12 10v1" />
                      <path d="M12 17v1" />
                    </svg>

                    <div>{'Connect your wallet to see the available staking pools.'}</div>
                  </TYPE.mediumHeader>
                  <ButtonPrimary style={{ marginTop: '2em', padding: '8px 16px' }} onClick={toggleWalletModal}>
                    Connect a wallet
                  </ButtonPrimary>
                </div>
              </ConnectWalletContainer>
            ) : (
              <MainContentWrapper>
                <GridStyled>
                  <STHYPEPoolCard />
                  <LHYPEPoolCard />
                  <HSPXPoolCard />
                  <HypePoolCard />
                </GridStyled>
              </MainContentWrapper>
            )}
          </AutoColumn>
        </AutoColumn>
      </ContainerStyled>
    </>
  )
}
export default StakeList
